import Vue from 'vue'
import VuetifyConfirm from 'vuetify-confirm'
import { vuetify } from './vuetify'

Vue.use(VuetifyConfirm, { vuetify })
